<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>{{ 'AUTOMATIONS.COMMON.AUTOMATIONS' | translate }}</mat-expansion-panel-header>

  <ng-container *ngIf="(this.creatingAccountGroup$ | async) === false; else loadingSpinner">
    <div
      [matTooltip]="startAutomationButtonTooltip$ | async | translate"
      [matTooltipDisabled]="(isUserSuperAdmin$ | async) === false"
    >
      <button
        mat-stroked-button
        color="primary"
        class="card-button"
        type="button"
        (click)="onTriggerAutomationButtonClicked()"
        [disabled]="isUserSuperAdmin$ | async"
      >
        <mat-icon>add</mat-icon>
        {{ 'AUTOMATIONS.COMMON.START_AUTOMATION' | translate }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="latestAutomations$ | async as automations">
    <ng-container *ngFor="let automation of automations">
      <mat-card class="association-card-contents">
        <mat-card-title>
          @if (canModifyAutomations()) {
            <a class="truncate" (click)="handleAutomationClick(automation.id)">
              {{ automation.name }}
            </a>
          } @else {
            {{ automation.name }}
          }
        </mat-card-title>
        <mat-card-subtitle *ngIf="automation.description">{{ automation.description }}</mat-card-subtitle>
      </mat-card>
    </ng-container>
  </ng-container>

  @if (canModifyAutomations()) {
    <button mat-stroked-button color="primary" class="card-button" type="button" (click)="handleViewAllClick()">
      {{ 'AUTOMATIONS.COMMON.VIEW_ALL' | translate }}
    </button>
  }
</mat-expansion-panel>

<ng-template #loadingSpinner>
  <glxy-loading-spinner id="spinner-container" [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
</ng-template>
